import React, { useCallback, useMemo } from "react";
import { useHistory, useParams } from "react-router-dom";
import { GlobalMarginCallFinalModal } from "./GlobalMarginCallFinalModal";
import { useMutation } from "react-query";
import { useAuth } from "hooks/useAuth";
import { useCompany } from "hooks/useCompany";
import { MarginFinalNotice } from "../../../interfaces/data";

export function GlobalMarginCallFinalAdd() {
  const history = useHistory();
  const { token } = useAuth();
  const { id, marginCallId } = useParams<{
    id: string;
    marginCallId?: string;
  }>();
  const { company } = useCompany({ id });
  const { mutate, isLoading } = useMutation(
    (finalNotice: MarginFinalNotice) => {
      return fetch(`${process.env.REACT_APP_DEV_FUNCTIONS_DOMAIN}/api/margin-calls/final-notice`, {
        method: "POST",
        body: JSON.stringify(finalNotice),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
    },
    {
      onSuccess: () => {
        history.push(`/companies/${id}`);
      },
    }
  );

  const marginCall = useMemo(() => {
    if (!company) {
      return;
    }
    return company.globalMarginCalls?.find((marginCall) => marginCall.id === marginCallId);
  }, [marginCallId, company]);

  const handleClose = useCallback(() => {
    history.push(`/companies/${id}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOnSaveAction = useCallback(
    (finalNotice: MarginFinalNotice) => {
      mutate(finalNotice);
    },
    [mutate]
  );

  if (!marginCall) {
    return null;
  }

  return (
    <GlobalMarginCallFinalModal
      isDisabled={isLoading}
      marginCall={marginCall}
      onClose={handleClose}
      onSave={handleOnSaveAction}
    />
  );
}
